module.exports = __webpack_public_path__ + "static/media/mn.1b4928e5.svg";